var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr } from '@ember-data/model';
import { fragment } from 'ember-data-model-fragments/attributes';
import EmberDataBaseModel from '@square/dashboard-data/models/ember-data-base-model';
let DomainTerm = (_dec = attr('number'), _dec2 = attr('number'), _dec3 = attr('number'), _dec4 = attr('number'), _dec5 = attr('number'), _dec6 = attr('string'), _dec7 = attr('string'), _dec8 = attr('string'), _dec9 = attr('date'), _dec10 = attr('date'), _dec11 = attr('boolean'), _dec12 = fragment('ecom/service-item'), _class = class DomainTerm extends EmberDataBaseModel {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "termLength", _descriptor, this);
    _initializerDefineProperty(this, "price", _descriptor2, this);
    _initializerDefineProperty(this, "whoisPrice", _descriptor3, this);
    _initializerDefineProperty(this, "priceWithoutWhois", _descriptor4, this);
    _initializerDefineProperty(this, "annualPrice", _descriptor5, this);
    _initializerDefineProperty(this, "currencyCode", _descriptor6, this);
    _initializerDefineProperty(this, "internalName", _descriptor7, this);
    _initializerDefineProperty(this, "type", _descriptor8, this);
    _initializerDefineProperty(this, "expirationDate", _descriptor9, this);
    _initializerDefineProperty(this, "newExpirationDate", _descriptor10, this);
    _initializerDefineProperty(this, "privacyProtection", _descriptor11, this);
    _initializerDefineProperty(this, "serviceItem", _descriptor12, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "termLength", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "price", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "whoisPrice", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "priceWithoutWhois", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "annualPrice", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "currencyCode", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "internalName", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "type", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "expirationDate", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "newExpirationDate", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "privacyProtection", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "serviceItem", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { DomainTerm as default };